import React from 'react';
import { TagsManager } from '../components/food-tags/TagsManager';

export const FoodTags: React.FC = () => (
  <TagsManager
    title="Food Tags"
    subtitle="Manage restaurant and grocery tags, their availability, and their icons"
  />
);
